module.exports = __webpack_public_path__ + "static/media/duet-logo.9a04b7c9.png";